import { Component, OnInit, ViewChild } from "@angular/core";
import { PolizaService } from "./polizas.service";
import { ListColumn } from "src/app/models/list-columns.model";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { PolizaForm } from "./form/form.component";
import Swal from "sweetalert2";
import { LayoutsService } from "src/app/services/layouts.service";
import { UnidadesDTO } from "src/app/models/unidades.dto";
import { AlertasSwalService } from "src/app/services/alerts.service";

@Component({
  selector: "app-polizas",
  templateUrl: "./polizas.component.html",
  styles: [],
})
export class PolizasComponent implements OnInit {
  public actions: any[] = [
    {
      desc: "Actualizar",
      action: "update",
      visible: (row) => true,
    },
  ];

  public columns: ListColumn[] = [
    {
      name: "# Control",
      property: "NoControl",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Modelo",
      property: "Modelo",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Placas",
      property: "Placas",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Serie",
      property: "Serie",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Tipo Unidad",
      property: "TipoUnidad",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Empresa",
      property: "Empresa",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  @ViewChild("tbl", { static: true })
  public tableComp: CardTableComponent;

  @ViewChild(PolizaForm, { static: true })
  public formulario: PolizaForm;

  filtro: string = "";
  realdata: UnidadesDTO[];

  constructor(
    public service: PolizaService,
    public layoutServ: LayoutsService,
    public alerts: AlertasSwalService
  ) {
    this.layoutServ.changeHeader("Polizas");
  }
  ngOnInit(): void {
    this.loadRecords();
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData
          .filter((f) => f.Activo)
          .sort((a, b) => a.NoControl - b.NoControl);
        this.filterdata();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  filterdata() {
    let filterdata = this.realdata;

    if (this.filtro.trim().length > 0) {
      const filtoLower = this.filtro.toLocaleLowerCase().trim();
      filterdata = filterdata.filter(
        (f) =>
          ((f.NoControl ?? "").toLocaleLowerCase() as string).indexOf(
            filtoLower
          ) > -1 ||
          ((f.Modelo ?? "").toLocaleLowerCase() as string).indexOf(filtoLower) >
            -1 ||
          ((f.Placas ?? "").toLocaleLowerCase() as string).indexOf(filtoLower) >
            -1 ||
          ((f.Serie ?? "").toLocaleLowerCase() as string).indexOf(filtoLower) >
            -1 ||
          ((f.TipoUnidad ?? "").toLocaleLowerCase() as string).indexOf(
            filtoLower
          ) > -1 ||
          ((f.Empresa ?? "").toLocaleLowerCase() as string).indexOf(
            filtoLower
          ) > -1
      );
    }

    this.tableComp.setData(filterdata);
  }
  actionstable(e: { action: string; row: any }) {
    if (e.action == "update") {
      this.formulario.setUpdate(e.row);
    }
  }
}
